import { jsx as _jsx } from "react/jsx-runtime";
import { Calendar as HeroCalendar } from '@heroui/react';
export const Calendar = (props) => {
    return _jsx(HeroCalendar, { ...props });
};
export default Calendar;
//# sourceMappingURL=Calendar.js.map